var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.698,
    height: 22.426,
    viewBox: "0 0 15.698 22.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prescription",
    d: "M20.884,4H11.121A1.122,1.122,0,0,0,10,5.121V25.3a1.122,1.122,0,0,0,1.121,1.121H24.577A1.122,1.122,0,0,0,25.7,25.3V8.814Zm.329,1.914,2.571,2.571H21.213ZM11.121,25.3V5.121h8.97V8.485a1.122,1.122,0,0,0,1.121,1.121h3.364V25.3ZM12.243,19.7h8.97V20.82h-8.97Zm0-2.243H23.456v1.121H12.243Zm1.682-3.925H12.243V12.41h1.682V10.728h1.121V12.41h1.682v1.121H15.046v1.682H13.925Z",
    transform: "translate(-10 -4)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescription);
export default __webpack_public_path__ + "static/media/prescription.fa333538bdfd09a09214919859518776.svg";
export { ForwardRef as ReactComponent };